// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import PostTile from 'church-theme-library/components/PostTile/PostTile'
import ArchiveDate from 'church-theme-library/components/ArchiveDate/ArchiveDate'
import LoadingSpinner from 'church-theme-library/components/LoadingSpinner/LoadingSpinner'
import { formattedDate } from 'church-theme-library/utilities/date'

// Redux:
import { loadMorePosts } from 'church-theme-library/redux/actions/page'

class PostSectionB extends React.Component {
	static defaultProps = {
		type: 'posts',
		posts: [],
		start: 0,
		end: undefined,
		showDateSelect: true,
		firstAsFeature: false,
		heading: ''
	}

	loadMorePosts = () => {
		const { dispatch, type } = this.props

		dispatch( loadMorePosts( type ) )
	}

	render() {
		const { type, posts, end, showDateSelect, firstAsFeature, heading, postStyle, loadingById } = this.props
		let { start } = this.props
		let classNameMobile = 'posts-section-b-mobile'
		let className = 'posts-section-b'
		let firstFeatureMarkup,
			firstFeatureMobileMarkup,
			featurePost

		if ( firstAsFeature ) {
			classNameMobile += ' with-first-as-feature'
			className += ' with-first-as-feature'
			featurePost = posts.slice( start, start + 1 )[0]
			start = start + 1

			let author = featurePost.author

			if ( featurePost.is_event ) {
				author = ''
			}

			firstFeatureMarkup = (
				<PostTile
					key={ featurePost.id }
					url={ featurePost.url }
					title={ featurePost.title }
					author={ author }
					date={ formattedDate( featurePost ) }
					image={ featurePost.featured_image }
					imageAlt={ featurePost.title }
					direction="vertical"
					size="medium"
					order="image-text"
					className="is-feature"
					wrapClassName="is-feature"
					postStyle={ postStyle }
				/>
			)

			firstFeatureMobileMarkup = (
				<PostTile
					key={ featurePost.id }
					url={ featurePost.url }
					title={ featurePost.title }
					author={ author }
					date={ formattedDate( featurePost ) }
					image={ featurePost.featured_image }
					imageAlt={ featurePost.title }
					direction="horizontal"
					size="small"
					order="text-image"
					className="is-feature"
					wrapClassName="is-feature"
					postStyle={ postStyle }
				/>
			)
		}

		let i = 0,
			numberSinceLastFeatured = 0,
			setBNumber = posts.length - start

		let setBMarkup = posts.slice( start, end ).map( ( item ) => {
			i++
			numberSinceLastFeatured++

			let className = '',
				wrapClassName = '',
				author = item.author

			if ( item.category && item.category.is_featured && numberSinceLastFeatured > 6 ) {
				className = 'is-feature'
				wrapClassName = 'is-feature'
				numberSinceLastFeatured = 0
			}

			if ( item.is_event ) {
				author = ''
			}

			if ( i == ( setBNumber - 3 ) ) {
				// With waypoint to trigger the fetch of more posts:
				return (
					<PostTile
						key={ item.id }
						url={ item.url }
						title={ item.title }
						author={ author }
						date={ formattedDate( item ) }
						image={ item.featured_image }
						imageAlt={ item.title }
						direction="vertical"
						size="medium"
						order="image-text"
						className={ className }
						wrapClassName={ wrapClassName }
						handleWaypointEnter={ this.loadMorePosts }
						postStyle={ postStyle }
					/>
				)
			} else {
				return (
					<PostTile
						key={ item.id }
						url={ item.url }
						title={ item.title }
						author={ author }
						date={ formattedDate( item ) }
						dateRecurText={ item.recur_text }
						image={ item.featured_image }
						imageAlt={ item.title }
						direction="vertical"
						size="medium"
						order="image-text"
						className={ className }
						wrapClassName={ wrapClassName }
						postStyle={ postStyle }
					/>
				)
			}
		})

		i = 0,
		numberSinceLastFeatured = 0,
		setBNumber = posts.length - start

		let setBMarkupMobile = posts.slice( start, end ).map( ( item ) => {
			i++
			numberSinceLastFeatured++

			let className = '',
				wrapClassName = '',
				author = item.author

			if ( item.category && item.category.is_featured && numberSinceLastFeatured > 6 ) {
				className = 'is-feature'
				wrapClassName = 'is-feature'
				numberSinceLastFeatured = 0
			}

			if ( item.is_event ) {
				author = ''
			}

			if ( i == ( setBNumber - 3 ) ) {
				// With waypoint to trigger the fetch of more posts:
				return (
					<PostTile
						key={ item.id }
						url={ item.url }
						title={ item.title }
						author={ author }
						date={ formattedDate( item ) }
						image={ item.featured_image }
						imageAlt={ item.title }
						handleWaypointEnter={ this.loadMorePosts }
						direction="horizontal"
						size="small"
						order="text-image"
						className={ className }
						wrapClassName={ wrapClassName }
						postStyle={ postStyle }
					/>
				)
			} else {
				return (
					<PostTile
						key={ item.id }
						url={ item.url }
						title={ item.title }
						author={ author }
						date={ formattedDate( item ) }
						image={ item.featured_image }
						imageAlt={ item.title }
						direction="horizontal"
						size="small"
						order="text-image"
						className={ className }
						wrapClassName={ wrapClassName }
						postStyle={ postStyle }
					/>
				)
			}
		})

		return (
			<React.Fragment>
				<section className={ classNameMobile }>
					<div className="-inner">
						{ firstFeatureMobileMarkup }

						{ heading &&
							<div className="-heading">
								<h2>{ heading }</h2>
							</div>
						}

						{ setBMarkupMobile }

						{ loadingById && loadingById.morePosts &&
							<LoadingSpinner />
						}
					</div>
				</section>

				<section className={ className }>
					<div className="-inner">
						<div className="-primary">
							{ firstFeatureMarkup &&
								<section className="-posts is-feature">
									<div className="-inner">
										<section>
											{ firstFeatureMarkup }
										</section>
									</div>
								</section>
							}

							{ ( !! setBMarkup.length ) &&
								<section className="-posts">
									{ heading &&
										<div className="-heading">
											<h2>{ heading }</h2>

											{ showDateSelect &&
												<ArchiveDate />
											}
										</div>
									|| showDateSelect &&
										<ArchiveDate />
									}

									<div className="-inner">
										<section>
											{ setBMarkup }

											{ loadingById && loadingById.morePosts &&
												<LoadingSpinner />
											}
										</section>
									</div>
								</section>
							}
						</div>
					</div>
				</section>
			</React.Fragment>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		loadingById: state.page.loadingById
	}
}

export default connect( mapStateToProps )( PostSectionB )
